/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Master10Inputs */

const en__field_enum_tuda_master10 = /** @type {(inputs: _Field_Enum_Tuda_Master10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

const de__field_enum_tuda_master10 = /** @type {(inputs: _Field_Enum_Tuda_Master10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

/**
* | output |
* | --- |
* | "Master" |
*
* @param {_Field_Enum_Tuda_Master10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_master10 = /** @type {((inputs?: _Field_Enum_Tuda_Master10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Master10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_master10(inputs)
	return de__field_enum_tuda_master10(inputs)
});
export { _field_enum_tuda_master10 as "_field_enum_TUDA_MASTER" }